<template>
  <div id="app">
    <transition name="fade">
      <div>
        <keep-alive>
          <router-view v-if="$route.meta.keepalive" :include="includeList" :exclude="excludeList">
          </router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepalive">
          <!-- 这里是不被缓存的视图组件 -->
        </router-view>
      </div>
    </transition>
  </div>
</template>

<script>

  import {HOST} from "@/config/index";
  import {isWeixin} from "@/utils/tools";
  import {appid} from '@/config'
  import axios from 'axios'
  require('@/utils/native');
  axios.defaults.baseURL = HOST;
  export default {
    name: 'App',
    data () {
      return {
        code: '',
        winUrl: '',
          includeList: ['orderList'],
          excludeList: [ 'historyList'],
      }
    },
    methods:{
      getCode () {
        this.code = ''
        var local = window.location.href // 获取页面url
        this.code = this.getUrlCode().code // 截取code
        if (this.code == null || this.code === '') { // 如果没有code，则去请求
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`
        } else {
          axios.get(`station/pdah5/v1/gasUser/wxAccessToken?code=${this.code}&state=STATE`).then(res=>{
            if (res.data.code === 0 ){
               let g7openId = res.data.data.openid
               window.localStorage.setItem('g7openId',g7openId)
            }else{
              console.log(res.data.msg)
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      },
      getUrlCode() { // 截取url中的code方法
        var url = location.search
        this.winUrl = url
        var theRequest = new Object()
        if (url.indexOf("?") != -1) {
          var str = url.substr(1)
          var strs = str.split("&")
          for(var i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
        }
        return theRequest
      }

    },
    mounted(){

      // 记录进入 App 时的 URL
      if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
        window.entryUrl = location.href.split('#')[0]
      }
      if(isWeixin()) {
          if(!window.localStorage.getItem('g7openId')){ // 如果缓存localStorage中没有微信openId，则需用code去后台获取
              this.getCode()
          } else {
              // 别的业务逻辑
          }
      } else{
          window.remote = {
              closeCurrentPage: () => {
                  history.go(-1);
              }
          }
          native.goBack('remote.closeCurrentPage');
      }

        /*location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3d57ca38506068c2&redirect_uri=http%3A%2F%2Fpda.dev.chinawayltd.com&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect'
        let a = query2json(location.search)

        if (a.code){
          getOpenIDApi(a.code).then(res => {
            if (res.code === 0) {
              console.log(res)
            } else {
              console.log(res.msg)
            }
          }).catch(err => {
            console.log(err.message)
          })
        }*/

    },
    computed:{
      /*hasFooter () {
        return ['/','/mine','/orderList'].includes(this.$route.path)
      }*/
    },
    components: {}
  }

</script>

<style lang="less">
  // @import "assets/css/reset";
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: #333;
  background-color: #F2F2F2;
}
@font-face {
  font-family: 'E6';
  src:url('/font/MiSans-Normal.ttf');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'E6';
  src:url('/font/MiSans-Bold.ttf');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'E6';
  src:url('/font/MiSans-Regular.ttf');
  font-weight: normal;
  font-style: normal;
}
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'E6' !important;
}
</style>
<style scoped>
  /* 路由切换动效 */
  .fade-leave-active {
    transition-duration: 0s;
  }

  .fade-enter-active {
    /*transition: all .5s;*/
    opacity: 1;
    transition: opacity 1s linear;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
</style>
